export default (value: any): boolean | undefined => (typeof value === 'boolean' ? value : undefined);
